import { useEffect, useRef, useState } from "react";

export const DualScroll = ({ className = "", children }) => {
  const topRef = useRef(null);
  const bodyRef = useRef(null);
  const [w, setW] = useState(0);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const el = bodyRef.current;
    if (!el) { return; }
    const update = () => {
      setW(el.scrollWidth);
      setShow(el.scrollWidth > el.clientWidth + 1);
    };
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    if (el.firstElementChild) { ro.observe(el.firstElementChild); }
    return () => { ro.disconnect(); };
  }, [children]);

  const sync = (from, to) => {
    if (from.current && to.current && to.current.scrollLeft !== from.current.scrollLeft) {
      to.current.scrollLeft = from.current.scrollLeft;
    }
  };

  return (
    <div className={className}>
      {show && (
        <div ref={topRef} onScroll={() => sync(topRef, bodyRef)} className="overflow-x-auto overflow-y-hidden border-b border-border" style={{ height: 14 }} data-testid="subs-top-scroll">
          <div style={{ width: w, height: 1 }} />
        </div>
      )}
      <div ref={bodyRef} onScroll={() => sync(bodyRef, topRef)} className="overflow-x-auto" data-testid="subs-body-scroll">
        {children}
      </div>
    </div>
  );
};
